<template>
	<v-toolbar dense class="video-toolbar">
		<v-row>
		<v-col cols="6" sm="5" class="pr-0 pl-0 pt-5">
			<IncognitoButton :room="room" :incognito="settings.incognito"></IncognitoButton>
			<ShareScreenButton v-if="!isMobile && !settings.incognito" :room="room" :settings="settings"></ShareScreenButton>
			<AVSettings v-bind="participant" :settings="settings" :room="room"></AVSettings>
		</v-col>
		<v-col cols="2" class="text-center" v-if="!isMobile"> 
			<EndCallButton :room="room" :twilioObject="twilioObject"></EndCallButton>
		</v-col>
		<v-col cols="6" sm="5" class="text-right pr-0 pl-0 pt-5"> 
			<RoomOverview :room="room"></RoomOverview>
			<v-btn class="mr-1" icon small text color="black" @click="$emit('toggleSidebar','info')"><v-icon small>mdi-information</v-icon></v-btn>

			<v-btn v-if="userCanMakeNotes" class="mr-1" icon small text color="black" @click="$emit('toggleSidebar','notes')"><v-icon small>mdi-note-text-outline</v-icon></v-btn>
			<v-btn class="mr-1" icon small text color="black" @click="$emit('toggleSidebar','chat')"><v-icon small>mdi-chat</v-icon></v-btn>
		</v-col>
		</v-row>
	</v-toolbar>
</template>

<style lang="less">
	.video-toolbar {
		background-color: white;
	}
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	import AVSettings from "./AVSettings"
	import EndCallButton from "./EndCallButton"
	import IncognitoButton from "./IncognitoButton.vue"
	import RoomOverview from "./RoomOverview"
	import ShareScreenButton from "./ShareScreenButton"
	export default {
		name: "VideoToolbar", 
		props: {
			room: {},
			twilioObject: {},
			settings: {}		
		},
		data: () => {
			return {
				bottom_sheet: false
			}
		},
		components: {
			AVSettings,
			RoomOverview, 
			EndCallButton,
			IncognitoButton,
			ShareScreenButton
		},
		computed: {
			...Vuex.mapState({
				user: state => state.auth.user, 
				role: state => state.auth.view,
				participant: state => state.video.participant
			}),
			isMobile(){
				return this.$vuetify.breakpoint.xs
			},
			userCanMakeNotes(){
				return this.role !== "participant"
			}
		},
		// methods: {
		// }
		// created(){
			
		// }

	}
// </script>"